<template>

    <header :class="{ 'header-scrolled': isScrolled }">
        <div class="container__header">
            <div class="logo">
                <!--href="../App.vue"-->
                <router-link to="/"><img alt="PYPA" src="../assets/logo/logoultrafinal9.svg"></router-link>
            </div>

            <div class="menu">
                <nav>
                    <ul>
                        <li>
                            <router-link to="/">
                                <v-icon icon="mdi-home" size="small" class="mr-1"></v-icon>Inicio
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/servicios" active-class="active-link">
                                <v-icon icon="mdi-lightbulb-outline" size="small" class="mr-1"></v-icon>Soluciones
                            </router-link>
                        </li>
                        <li v-if="isLoggedIn && !isPublicRoute">
                            <router-link to="/roadmap" active-class="active-link">
                                <v-icon icon="mdi-map-marker-path" size="small" class="mr-1"></v-icon>Roadmap
                            </router-link>
                        </li>
                        <li v-if="isLoggedIn && !isPublicRoute">
                            <router-link to="/cotizaciones/ingreso" active-class="active-link">
                                <v-icon icon="mdi-file-document-outline" size="small" class="mr-1"></v-icon>Cotizaciones
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/#contacto" :class="{ 'active-link': isContactActive }">
                                <v-icon icon="mdi-email-outline" size="small" class="mr-1"></v-icon>Contáctenos
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </div>
            
            <div class="header__register">
                <router-link v-if="!isLoggedIn" to="/login">
                    <button type="button" class="btn__header-register">Iniciar Sesión</button>
                </router-link>
                <button v-else @click="logout" type="button" class="btn__header-register" style="background: #dc2626;">Cerrar Sesión</button>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name:'MenuHeader',
    data() {
        return {
            isScrolled: false,
            isContactActive: false,
            isLoggedIn: false
        }
    },
    watch: {
        '$route'() {
            this.checkLoginStatus();
            this.handleScroll();
        }
    },
    computed: {
        isPublicRoute() {
            return ['/', '/servicios', '/login'].includes(this.$route.path);
        }
    },
    methods: {
        handleScroll() {
            // Si bajamos más de 50px, o si no estamos en una página con fondo oscuro (Inicio, Servicios o Login), activamos el fondo sólido
            const darkBgPages = ['/', '/servicios', '/login'];
            this.isScrolled = window.scrollY > 50 || !darkBgPages.includes(this.$route.path);

            // Detectar si la sección de contacto está visible
            const contactSection = document.getElementById('contacto');
            if (contactSection) {
                const rect = contactSection.getBoundingClientRect();
                // Se activa si la sección está en la mitad visible de la pantalla
                this.isContactActive = rect.top <= window.innerHeight / 2 && rect.bottom >= 100;
            } else {
                this.isContactActive = false;
            }
        },
        checkLoginStatus() {
            this.isLoggedIn = !!localStorage.getItem('isLoggedIn');
        },
        logout() {
            localStorage.removeItem('isLoggedIn');
            this.isLoggedIn = false;
            this.$router.push('/');
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.checkLoginStatus();
        this.handleScroll();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style>
header{
   height: 80px;
   position: fixed;
   width: 100%;
   top: 0;
   left: 0;
   z-index: 1000;
   transition: all 0.3s ease;
   background-color: transparent; /* Transparente por defecto */
}

/* Estilo cuando se hace scroll */
header.header-scrolled {
    background-color: white; /* Blanco sólido al bajar */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Sombra suave */
    height: 60px; /* Opcional: se hace un poco más compacto */
}

.container__header{
    margin:auto;
    max-width: 1200px;
    padding: 10px 40px 30px 40px; /* Reducimos el espacio superior para 'subir' el menú */
    transition: padding 0.3s ease;
    display: flex;
        justify-content:space-between;
        align-items:center;
       /*border: 10px solid green*/
}

/* Ajustamos el padding interno también al bajar */
header.header-scrolled .container__header {
    padding: 5px 40px 15px 40px; /* Ajuste proporcional para cuando la barra se achica al bajar */
}

.logo {
    display: flex;
    align-items: center;
}

.logo img{
    width: 150px;
    display: block; /* Importante: elimina el espacio extra abajo de la imagen */
    transition: filter 0.3s ease;
}

/* Vuelve el logo blanco cuando el menú es transparente para que se vea sobre el video */
header:not(.header-scrolled) .logo img {
    filter: brightness(0) invert(1);
}

.menu{
    flex-grow: 2;
    display: flex;
    justify-content: flex-start; /* Alineamos a la izquierda para acercar los nombres al logo */
    align-items: center;
    margin-left: 40px; /* Pequeña separación para que no quede pegado al logo */
}

.menu nav ul{
    padding: 0px;
    margin: 0px;
    display: flex;
    gap: 10px; /* Usamos gap para separar los botones en lugar de padding */
}

.menu nav ul li{
    list-style:none;
    padding: 0; /* Quitamos el padding del li */
}

.menu nav ul li a{
    cursor: pointer;
    font-size: 15px;
    text-decoration: none;
    color: white; /* Blanco por defecto para ver sobre el video */
    padding: 10px 20px; /* Relleno para dar forma de botón */
    border-radius: 12px; /* Bordes redondeados igual que el botón principal */
    transition: all 0.2s ease;
    font-weight: 500;
}

.menu nav ul li a:hover,
.menu nav ul li a.active-link {
    background-color: #0456A4; /* Azul corporativo al pasar el mouse */
    color: white !important; /* Fuerza el texto blanco cuando el enlace es un botón azul */
    transform: translateY(-2px); /* Pequeña elevación */
    box-shadow: 0 4px 10px rgba(4, 86, 164, 0.2); /* Sombra suave */
}

/* Cuando se hace scroll, el texto vuelve a ser oscuro */
header.header-scrolled .menu nav ul li a {
    color: #374151;
}

.header__register{
    /*width: 40%;
    text-align: right;
    background: blueviolet;*/

}

.btn__header-register{
    padding: 10px 24px;
    border: none;
    background: #0456A4;
    color: white;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.2s ease;
}

.btn__header-register:hover{
    background: #033e75;
    transform: translateY(-2px);
    color: white;
}

@media (max-width: 768px) {
    .container__header {
        padding: 10px 15px 15px 15px;
    }
    header.header-scrolled .container__header {
        padding: 5px 15px 10px 15px;
    }
    .logo img {
        width: 110px;
    }
    .menu {
        margin-left: 15px;
    }
    .menu nav ul {
        gap: 4px;
    }
    .menu nav ul li a {
        font-size: 13px;
        padding: 8px 12px;
    }
    .btn__header-register {
        padding: 8px 16px;
        font-size: 13px;
    }
}

@media (max-width: 580px) {
    .container__header {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 10px;
        padding: 10px 20px;
    }
    .menu {
        order: 3;
        width: 100%;
        margin-left: 0;
        justify-content: center;
    }
    .menu nav ul {
        width: 100%;
        justify-content: space-around;
    }
    header {
        height: auto;
    }
    header.header-scrolled {
        height: auto;
    }
}

</style>